import { Role } from '../../../../store/roles/types';
import { orderByAlphabetical } from '../../../../services/stringServices';

export const getOrderedRoles = (roles: Role[]): Role[] =>
  roles
    .sort((a, b) => orderByAlphabetical(a.name, b.name))
    .sort((a, b) => orderByAlphabetical(a?.industryName || '', b?.industryName || ''));